import { List } from 'immutable';

/**
 * How many cards the step takes when there are `available` to take: exactly the step's count, or, for "up to"
 * (Super Energy Removal, Energy Retrieval), as many as there are up to that count.
 *
 * @param {Map} step one of a card's trainer_steps or a move's power_steps
 */
export const cardsToPick = (step, available) => (
  step.get('up_to') ? Math.min(step.get('count'), available) : step.get('count')
);

/** The Pokémon's energy cards the step can take: of the step's energy type, if it names one (Energy Trans). */
export const energiesFor = (step, energyAttachments) => {
  const energies = energyAttachments || List();
  const type = step.get('energy_type');
  return type ? energies.filter(attachment => attachment.get('provides') === type) : energies;
};

/**
 * The energy cards the step takes from the Pokémon when there is no real choice, or null when the player picks.
 * There's no choice when the step takes none, takes every card there is, or every card is the same kind.
 *
 * @param {Map} step
 * @param {List} energyAttachments the Pokémon's energy cards
 */
export const energyWithoutChoice = (step, energyAttachments) => {
  const energies = energiesFor(step, energyAttachments);
  const count = cardsToPick(step, energies.size);
  const ids = energies.map(attachment => attachment.get('id'));

  if (count === 0) {
    return List();
  }
  if (energies.size <= count || energies.map(attachment => attachment.get('card_id')).toSet().size === 1) {
    return ids.take(count);
  }
  return null;
};

/**
 * Whether a Pokémon was already picked by an earlier step on the same side: a Power that moves something (Energy
 * Trans, Damage Swap) moves it to a different Pokémon.
 */
export const pickedBefore = (picks, from, at) => picks.some(pick => pick.get('from') === from && pick.get('at') === at);

/** The request's `picks`, one per step, in the server's words. */
export const picksRequest = (picks) => picks.map((pick) => {
  if (pick.has('positions')) {
    return { positions: pick.get('positions').toArray() };
  }
  if (pick.has('type')) {
    return { type: pick.get('type') };
  }
  return { at: pick.get('at'), energy_ids: pick.get('energyIds').toArray() };
}).toArray();
